module.exports = __webpack_public_path__ + "static/Opportunity_hires-2d06c41c8118c3e7d20b11ec8f40b724.jpg";